import { defineMessages } from 'react-intl';

export enum NavigationDropdownItem {
  browse = 'browse',
  dashboard = 'dashboard',
  libraryResources = 'libraryResources',
}

export const navigationMessages = defineMessages({
  expandBrowse: {
    id: 'navigation.expandBrowse',
    defaultMessage: 'Expand browse links',
  },
  collapseBrowse: {
    id: 'navigation.collapseBrowse',
    defaultMessage: 'Collapse browse links',
  },
  expandDashboard: {
    id: 'navigation.expandDashboard',
    defaultMessage: 'Expand dashboard links',
  },
  collapseDashboard: {
    id: 'navigation.collapseDashboard',
    defaultMessage: 'Collapse dashboard links',
  },
  browse: { id: 'navigation.browse', defaultMessage: 'Browse' },
  dashboard: { id: 'navigation.dashboard', defaultMessage: 'My dashboard' },
  signOut: { id: 'navigation.signOut', defaultMessage: 'Sign out' },
  libraryResources: {
    id: 'navigation.libraryResources',
    defaultMessage: 'Library resources',
  },
  expandLibraryResources: {
    id: 'navigation.expandLibraryResources',
    defaultMessage: 'Expand library resources',
  },
  collapseLibraryResources: {
    id: 'navigation.collapseLibraryResources',
    defaultMessage: 'Collapse library resources',
  },
});

export const navigationDropdownMessages = {
  [NavigationDropdownItem.browse]: {
    label: navigationMessages.browse,
    expand: navigationMessages.expandBrowse,
    collapse: navigationMessages.collapseBrowse,
  },
  [NavigationDropdownItem.dashboard]: {
    label: navigationMessages.dashboard,
    expand: navigationMessages.expandDashboard,
    collapse: navigationMessages.collapseDashboard,
  },
  [NavigationDropdownItem.libraryResources]: {
    label: navigationMessages.libraryResources,
    expand: navigationMessages.expandLibraryResources,
    collapse: navigationMessages.collapseLibraryResources,
  },
};
